export function normalizePhotoAttachmentsData(photoAttachments, defaultAttachmentType = 'Property Photo') {
  let sortOrder = 0;
  return photoAttachments.map((photoAttachment) => {
    const photoAttributes = {
      id: photoAttachment.photoId,
      _destroy: photoAttachment.deleted || false,
      attachmentType: photoAttachment.attachmentType || defaultAttachmentType,
      uploadId: photoAttachment.uploadId,
      delayProcessingStyles: true
    };

    const shallowCopy = { ...photoAttachment, photoAttributes };

    delete shallowCopy.deleted;
    delete shallowCopy.attachmentType;

    if (shallowCopy.uploaded) {
      delete shallowCopy.id;
      delete shallowCopy.photoId;
      delete shallowCopy.photoAttributes.id;
      delete shallowCopy.uploadId;
    }

    if (!shallowCopy.photoAttributes._destroy) {
      shallowCopy.sortOrder = sortOrder;
      sortOrder++;
    }

    return shallowCopy;
  });
}

export function normalizeVisualMediaEmbedsData(visualMediaEmbeds) {
  let sortOrder = 0;
  return visualMediaEmbeds.map((visualMediaEmbed) => {
    if (!visualMediaEmbed.destroy) {
      sortOrder++;
    }

    const mediaAttributes = {
      id: visualMediaEmbed.id,
      description: visualMediaEmbed.description,
      embedUrl: visualMediaEmbed.embedUrl.trim(),
      // Normalizing values from VisualMediaEmbedsCustomer given they're titleized
      mediaType: visualMediaEmbed.mediaType.toLowerCase().replaceAll(' ', '_'),
      _destroy: visualMediaEmbed.destroy || false
    };

    if (!mediaAttributes.hasOwnProperty('sortOrder')) {
      mediaAttributes.sortOrder = sortOrder;
    }

    return mediaAttributes;
  });
}

export function normalizeLeaseFloorPlan(floorPlan) {
  if (!floorPlan) {
    return {};
  }

  let floorAttributes;

  if (floorPlan.hasOwnProperty('uploaded')) {
    floorAttributes = {
      uploadId: floorPlan.uploadId,
      _destroy: floorPlan._destroy || false,
      id: floorPlan.id
    };

    if (!floorPlan.hasOwnProperty('id')) {
      floorAttributes.id = floorPlan.id;
    }
  } else {
    floorAttributes = {
      id: floorPlan.id,
      _destroy: floorPlan._destroy || false,
    };
  }

  return floorAttributes;
}
